import React from "react";

const EmptyClipboardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path d="M40 16H24C22.4087 16 20.8826 16.6321 19.7574 17.7574C18.6321 18.8826 18 20.4087 18 22V38C18 39.5913 18.6321 41.1174 19.7574 42.2426C20.8826 43.3679 22.4087 44 24 44H40C41.5913 44 43.1174 43.3679 44.2426 42.2426C45.3679 41.1174 46 39.5913 46 38V22C46 20.4087 45.3679 18.8826 44.2426 17.7574C43.1174 16.6321 41.5913 16 40 16Z" stroke="#A4A3A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 32H8C6.4087 32 4.88258 31.3679 3.75736 30.2426C2.63214 29.1174 2 27.5913 2 26V10C2 8.4087 2.63214 6.88258 3.75736 5.75736C4.88258 4.63214 6.4087 4 8 4H24C25.5913 4 27.1174 4.63214 28.2426 5.75736C29.3679 6.88258 30 8.4087 30 10V12" stroke="#A4A3A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default EmptyClipboardIcon;
